import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['mandatoryGroup', 'submit'];
  static values = { otherPagesAnswered: Boolean };

  connect() {
    this.updateSubmitState();
  }

  updateSubmitState() {
    if (!this.hasSubmitTarget) return;

    const currentPageSatisfied = this.mandatoryGroupTargets.every(
      (group) => this._groupSatisfied(group)
    );
    this.submitTarget.disabled = !(this.otherPagesAnsweredValue && currentPageSatisfied);
  }

  _groupSatisfied(group) {
    const choices = group.querySelectorAll('input[type=radio], input[type=checkbox]');
    if (choices.length) {
      return Array.from(choices).some((el) => el.checked);
    }

    const textFields = group.querySelectorAll('input[type=text], textarea');
    return Array.from(textFields).some((el) => el.value.trim() !== '');
  }
}
